import { render, staticRenderFns } from "./Endorsements.vue?vue&type=template&id=087b7163&lang=pug&"
import script from "./Endorsements.vue?vue&type=script&lang=js&"
export * from "./Endorsements.vue?vue&type=script&lang=js&"
import style0 from "./Endorsements.vue?vue&type=style&index=0&id=087b7163&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports